import CourseSectionScheduleElementService from "../CourseSectionScheduleElement/CourseSectionScheduleElement.service";
import SetService from "../../Services/Shared/Set.service";
export const SCHEDULABLE_TYPE = "Course Section";
export default class SchedulerCourseSectionService {
    static getBlocksFromSection(section, getContent) {
        const blocks = [];
        section.scheduleElements.forEach((elm) => {
            const days = new Set();
            if (elm.sunday) {
                days.add("sun");
            }
            if (elm.monday) {
                days.add("mon");
            }
            if (elm.tuesday) {
                days.add("tues");
            }
            if (elm.wednesday) {
                days.add("wed");
            }
            if (elm.thursday) {
                days.add("thur");
            }
            if (elm.friday) {
                days.add("fri");
            }
            if (elm.saturday) {
                days.add("sat");
            }
            blocks.push({
                startTime24: elm.startTimeHours24 + elm.startTimeMinutes24 / 60,
                endTime24: elm.endTimeHours24 + elm.endTimeMinutes24 / 60,
                content: getContent(elm),
                days,
            });
        });
        return blocks;
    }
    static fromJson(json) {
        // @ts-expect-error - TS2740 - Type '{ courseSectionStart: Date; courseSectionEnd: Date; }' is missing the following properties from type 'SchedulerCourseSection': id, section, code, name, and 6 more.
        return Object.assign(Object.assign({}, json), { courseSectionStart: new Date(json.courseSectionStart), courseSectionEnd: new Date(json.courseSectionEnd) });
    }
    static getDaysSet(sec) {
        // @ts-expect-error - TS2322 - Type 'Set<unknown>' is not assignable to type 'Set<"sunday" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday">'.
        return sec.scheduleElements.reduce((sum, elm) => SetService.union(sum, CourseSectionScheduleElementService.getDaysSet(elm)), new Set());
    }
    static getSchedulable(sec) {
        return {
            id: sec.id,
            startDate: sec.courseSectionStart,
            endDate: sec.courseSectionEnd,
            elms: sec.scheduleElements.map((elm) => elm),
        };
    }
    static getSchedulableTrail(sec) {
        return {
            id: sec.id,
            type: SCHEDULABLE_TYPE,
            child: SchedulerCourseSectionService.getSchedulable(sec),
        };
    }
    static getSchedulableSet(sec) {
        return {
            id: sec.id,
            type: SCHEDULABLE_TYPE,
            children: SchedulerCourseSectionService.getSchedulable(sec),
        };
    }
    static hasConflict(secA, secB, bufferMinutes = 0) {
        // Order the dates
        const sorted = [secA, secB].sort((a, b) => a.courseSectionStart > b.courseSectionStart ? 1 : -1);
        const first = sorted[0];
        const second = sorted[1];
        // Make sure that these course sections overlap.
        if (first.courseSectionEnd < second.courseSectionStart) {
            return false;
        }
        // Find the days of the week these sections have in common.
        const overlapTime = Math.max(first.courseSectionEnd.getMilliseconds(), second.courseSectionEnd.getMilliseconds()) - second.courseSectionStart.getMilliseconds();
        let overlapDays;
        // If the overlap is more than a week, just figure out what days these
        // course sections have in common
        if (overlapTime >= 1000 * 60 * 60 * 24 * 7) {
            overlapDays = SetService.union(SchedulerCourseSectionService.getDaysSet(first), SchedulerCourseSectionService.getDaysSet(second));
        }
        else {
            // TODO need to examine the overlap and figure out which days of the week exist in it.
            // for now, we just still consider every day.
            overlapDays = SetService.union(SchedulerCourseSectionService.getDaysSet(first), SchedulerCourseSectionService.getDaysSet(second));
        }
        const firstDays = {};
        const secondDays = {};
        for (const day of overlapDays) {
            firstDays[day] = first.scheduleElements.reduce((sum, elm) => elm[day]
                ? [
                    ...sum,
                    {
                        start: elm.startTimeHours24 + elm.startTimeMinutes24 / 60,
                        end: elm.endTimeHours24 + elm.startTimeMinutes24 / 60,
                    },
                ]
                : sum, []);
            secondDays[day] = second.scheduleElements.reduce((sum, elm) => elm[day]
                ? [
                    ...sum,
                    {
                        start: elm.startTimeHours24 + elm.startTimeMinutes24 / 60,
                        end: elm.endTimeHours24 + elm.startTimeMinutes24 / 60,
                    },
                ]
                : sum, []);
        }
        for (const day of overlapDays) {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            for (const firstInterval of firstDays[day]) {
                // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                for (const secondInterval of secondDays[day]) {
                    const ordered = [firstInterval, secondInterval].sort((a, b) => a.start - b.start);
                    if (ordered[0].end + bufferMinutes / 60 > ordered[1].start) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    static hasConflictArray(secA, secs, bufferMinutes = 0) {
        return secs.some((sec) => SchedulerCourseSectionService.hasConflict(secA, sec));
    }
}
